import React from "react";

import {Button, Col, message, Modal, Row} from "antd";
import {InfoCircleOutlined, PoweroffOutlined, SettingOutlined} from "@ant-design/icons";
import axios from "axios";
import {AuthHeader} from "../../helper/auth.token";
import {globalUrlPrefix} from "../../utils/const";
import {Link} from "react-router-dom";

import "./c240_header.css";
function C240Heaader(props) {

    function startScanner() {
        let id = 1;
        // this.setStartingScanner();
        let url = `/server/devices/` + id + '/start_scanner/';
        axios.get(url, { headers: { Authorization: AuthHeader() } })
            .then(response => {
                if (response.status === 200) {
                    alert("Initialized");
                    // this.setDoneStartingScanner();
                }
                else {
                    message.error("Failed to Start Scanner. Contact Admin");
                }
            })
            .catch(err => {
                console.log("INIT:: ", err);
            })
    }


    return (
        <div className="c240-header">
            <div className="settings">
                <Link to={"/" + globalUrlPrefix + "/c240_settings/" + props.deviceId}>
                    <SettingOutlined style={{fontSize: "32px"}}></SettingOutlined>
                </Link>
            </div>
            <div className="controls">
                {
                    props.blockUI || props.blurClassName == "blur" ? null : (props.queueState['ongoing'] === null && props.queueState['queue'].length === 0 ?
                        <div>
                            <Button className="open-gate-btn" disabled={props.blurClassName === "blur" || props.blockUI} size="medium" style={{marginLeft:'10px'}} onClick={props.openGateBtn}>
                                Open Gate
                            </Button>
                        </div>
                        :
                        <div>
                                <Button className="open-gate-btn" disabled={props.blurClassName === "blur" || props.blockUI} size="medium" style={{marginLeft:'10px'}} onClick={props.stopAfterCurrentScan}>
                                    <b>Open gate after current task</b>
                                </Button>
                                <Button disabled={props.blurClassName === "blur" || props.blockUI} size="medium"  style={{marginLeft:'10px'}} onClick={props.stopNow}>
                                    Interrupt current task and open gate
                                </Button>
                        </div>)
                }
                <Row style={{marginLeft: "10px"}}>
                    <Button icon={<PoweroffOutlined />} className="shutdown-scanner-btn" size="medium"  style={{marginTop:'10px', width:"100%"}}
                            onClick={() => Modal.confirm({
                                title: 'Are you sure you want to shutdown the scanner?',
                                icon: <InfoCircleOutlined></InfoCircleOutlined>,
                                onOk: props.handleScannerShutdown,
                                onCancel() { }
                            })} >
                        Shut Down Scanner
                    </Button>
                </Row>
                {/*<Button className="shutdown-scanner-btn" size="large"  style={{marginTop:'10px', width:"100%"}}*/}
                {/*        onClick={startScanner} >*/}
                {/*    Start Scanner*/}
                {/*</Button>*/}
            </div>
        </div>
    );
}

export default C240Heaader;